// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__rO6zU","logo":"Logo_logo__3384l","text":"Logo_text__IF6+E"};